import { Box, Separator, Shimmer } from '@betterment/samba-react';

import { ModalSection } from '../ModalSection';

export const ModalSectionLoading = () => {
  return (
    <ModalSection>
      <Box
        aria-label="Loading..."
        role="status"
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'space.200',
          maxWidth: 'container.large',
        }}
      >
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Shimmer css={{ height: 'size.200', width: '20%' }} />
          <Shimmer css={{ height: 'size.200', width: '10%' }} />
        </Box>
        <Separator />
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Shimmer css={{ height: 'size.200', width: '30%' }} />
          <Shimmer css={{ height: 'size.200', width: '10%' }} />
        </Box>
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Shimmer css={{ height: 'size.200', width: '30%' }} />
          <Shimmer css={{ height: 'size.200', width: '10%' }} />
        </Box>
      </Box>
    </ModalSection>
  );
};
